const lang = {
    ja: {
        'exhibition.exhibitorParticipants': '表示',
        'exhibition.productName': '画像',
        'exhibition.companyName': '社名',
        'exhibition.merchandise': '商品',
        'exhibition.industry': '業種',
        'exhibition.search': '{companyName}、{merchandise}、{industry}検索は右🔎を。',
        'exhibition.noteViewProduct': '出展企業の展示商品を見る場合、｢{directSelection}｣　をクリックするか、□に✓を入れ｢{buttonSee}｣　でまとめて見れます。',
        'exhibition.zone': 'すべて',
        'exhibition.apply': '申込みする',
        'exhibition.noteRegister': '{exhibition}への入場を申込む際は「申込みする」ボタンを押し、登録フォームより入場者の情報をご登録ください。',
        'exhibition.noExhibition': 'この催しに出展企業が何もありません。',
        'exhibition.browsingCompany': '閲覧企業チェック',
        'exhibition.noProductRegister': 'この出展企業に商品がまだ登録されていません。',
        'exhibition.detailInfo': '詳細情報',
        'exhibition.sendCompleted': '送信が完了しました。',
        'exhibition.addedToCart': 'カートへ入れました',
        'exhibition.documentDownload': '資料ダウンロード',
        'exhibition.boardSalon': '掲示板サロン',
        'exhibition.previousCompany': '前の企業',
        'exhibition.nextCompany': '次の企業',
        'exhibition.exhibitorDetailInfo': '出展企業詳細情報',
        'exhibition.addCart': 'カートに入れる',
        'exhibition.fax': 'ＦＡＸ番号',
        'exhibition.searchCompany': '{companyName}、{merchandise}',
        'exhibition.searchCompanyName': '{companyName}、',
        'exhibition.detailInfoButton': '出展企業',
        'exhibition.detailInfoExhibit': '詳細情報',
    },
    en: {
        'exhibition.exhibitorParticipants': 'List',
        'exhibition.productName': 'Image',
        'exhibition.companyName': 'Company name',
        'exhibition.merchandise': 'product name',
        'exhibition.industry': 'industry type',
        'exhibition.search': 'Please use the field on the right to search {companyName}, {merchandise}, or {industry}.',
        'exhibition.noteViewProduct': 'To view products exhibited by an exhibitor, click {directSelection} or check the box to view them in the “{buttonSee}”.',
        'exhibition.zone': 'All',
        'exhibition.apply': 'Apply',
        'exhibition.noteRegister': 'When you apply for entry of {exhibition}, click Apply button and register information of attendees using the registration form.',
        'exhibition.noExhibition': 'There is no exhibitor for this event.',
        'exhibition.browsingCompany': 'Check companies viewed',
        'exhibition.noProductRegister': 'Product has not been registered by this exhibitor yet.',
        'exhibition.detailInfo': 'Detailed information',
        'exhibition.sendCompleted': 'Submission completed.',
        'exhibition.addedToCart': 'Added to shopping cart.',
        'exhibition.documentDownload': 'Download brochure',
        'exhibition.boardSalon': 'Bulletin salon',
        'exhibition.previousCompany': 'Previous company',
        'exhibition.nextCompany': 'Next company',
        'exhibition.exhibitorDetailInfo': 'Detailed information of exhibitor',
        'exhibition.addCart': 'Add to shopping cart',
        'exhibition.fax': 'Fax No.',
        'exhibition.searchCompany': '{companyName}, {merchandise}',
        'exhibition.searchCompanyName': '{companyName},',
        'exhibition.detailInfoButton': 'Detailed information',
        'exhibition.detailInfoExhibit': 'of exhibitor',
    },
};

export default lang;
